// extracted by mini-css-extract-plugin
export default {"processItemLocation":"processItemLocation-2Ja98","instrumentName":"instrumentName-sCzOm","location":"location-eee_G"};